// ============================================
// useResponsive — devuelve el tamaño actual del viewport
// ============================================
// breakpoints estándar Beep:
//   mobile_xs:  < 480px   (1 columna)
//   mobile_lg:  480-767px (2 columnas)
//   tablet:     768-1023px (3 columnas)
//   desktop:    1024px+   (4 columnas)
// ============================================

import { useEffect, useState } from 'react';

function calcular() {
  if (typeof window === 'undefined') return 'desktop';
  const w = window.innerWidth;
  if (w < 480) return 'mobile_xs';
  if (w < 768) return 'mobile_lg';
  if (w < 1024) return 'tablet';
  return 'desktop';
}

// Ancho EXACTO del viewport, en vivo (se actualiza en cada resize). Para componentes
// que necesitan un umbral propio que NO cae en los breakpoints estandar, p.ej. mostrar
// tarjetas en un monitor PC VERTICAL (ancho ~1080 -> 'desktop' por breakpoint, pero
// angosto en la practica). Hook aparte para NO cambiar el re-render de useResponsive
// (que solo se dispara al cruzar breakpoint). Mismo patron que Dashboard.useWindowWidth.
export function useAnchoViewport() {
  const [ancho, setAncho] = useState(() => (typeof window === 'undefined' ? 1280 : window.innerWidth));
  useEffect(() => {
    const onResize = () => setAncho(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return ancho;
}

export function useResponsive() {
  const [size, setSize] = useState(calcular);

  useEffect(() => {
    function onResize() {
      const next = calcular();
      setSize(prev => (prev === next ? prev : next));
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    size,
    isMobile: size === 'mobile_xs' || size === 'mobile_lg',
    isMobileXs: size === 'mobile_xs',
    isTablet: size === 'tablet',
    isDesktop: size === 'desktop',
    columns: size === 'mobile_xs' ? 1 : size === 'mobile_lg' ? 2 : size === 'tablet' ? 3 : 4,
  };
}

export default useResponsive;
